import { render, staticRenderFns } from "./SupplierEditTabInformation.vue?vue&type=template&id=f6c2d98c&scoped=true&"
import script from "./SupplierEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./SupplierEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./SupplierEditTabInformation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SupplierEditTabInformation.vue?vue&type=style&index=1&id=f6c2d98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c2d98c",
  null
  
)

export default component.exports